<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.t-info
    +e.P.header {{content.infoHeader}}
    +e.info
      +e.SVG.lines(
        :width="width",
        :height="height",
      )
</template>


<script>
import { mapGetters } from 'vuex';
import d3 from '@/tools/d3/d3';
import margin from '../../mixins/margin';

export default {
  name: 't-info',

  mixins: [
    margin,
  ],

  data() {
    return {
      svg: null,
      activeCountry: '',
      width: 0,
      height: 0,
    };
  },

  props: {
    // Датасет для отображения
    dataSet: {
      type: Array,
      default: () => [],
    },
  },


  computed: {
    padded() {
      const width = this.width - this.margin.left - this.margin.right;
      const height = this.height - this.margin.top - this.margin.bottom;
      return { width, height };
    },

    ...mapGetters({
      lng: 'lng',
      content: 'getContent',
    }),
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    width: function widthChanged() {
      this.initialize();
    },
  },

  methods: {
    onResize() {
      this.width = this.$el.offsetWidth;
      this.height = this.$el.offsetHeight;
    },

    initialize() {
      this.svg = d3.select(this.$el.querySelector('.t-info__lines'))
        .attr('width', this.padded.width)
        .attr('height', this.padded.height);

      this.draw();
    },

    draw() {
      this.drawInfo();
    },

    drawInfo() {
      const self = this;

      const min = d3.min(self.dataSet, d => Math.min(d.CPIScore, d.CPIScorePrev));
      const max = d3.max(self.dataSet, d => Math.max(d.CPIScore, d.CPIScorePrev));

      const scale = d3.scaleLinear()
        .domain([min, max])
        .range([this.padded.height, 0]);


      self.svg.selectAll('.line')
        .data(this.dataSet)
        .enter()
        .append('line')
        .attr('x1', 20)
        .attr('y1', d => scale(d.CPIScorePrev))
        .attr('x2', this.padded.width - 20)
        .attr('y2', d => scale(d.CPIScore))
        .style('stroke', 'white')
        .style('stroke-width', '0.3')
        .attr('class', 'line');
        // .on('mouseover', function () {
        //   d3.select(this).style('stroke-width', '1');
        // })
        // .on('mouseout', function () {
        //   d3.select(this).style('stroke-width', '0.3');
        // });

      self.svg.selectAll('.line-text-left')
        .data(this.dataSet)
        .enter()
        .append('text')
        .attr('x', 0)
        .attr('y', d => scale(d.CPIScorePrev) + 2)
        .text(d => d.CPIScorePrev)
        .attr('fill', 'white')
        .attr('font-size', '12px')
        .attr('font-family', 'sans-serif')
        // .attr('x2', this.width - 20)
        // .attr('y2', d => scale(d.CPIScore))
        // .style('stroke', 'white')
        // .style('stroke-width', '0.3')
        .attr('class', 'line-text-left')
        .attr('opacity', '0');

      self.svg.selectAll('.line-text-right')
        .data(this.dataSet)
        .enter()
        .append('text')
        .attr('x', this.padded.width - 15)
        .attr('y', d => scale(d.CPIScore) + 2)
        .text(d => d.CPIScore)
        .attr('fill', 'white')
        .attr('font-size', '12px')
        .attr('font-family', 'sans-serif')
        .attr('class', 'line-text-right')
        .attr('opacity', '0');
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.t-info {
  position: relative;
  width: 100%;
  height: 100%;

  &__header {
    color: #fff;
    font-size: 12px;
    font-weight: 100;
  }

  &__info {
    position: relative;
    height: calc(100% - 20px);
  }

  &__svg {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TInfo/TInfo.vue